// The Safety Dashboard's start screen (2026-10-22): pick the data — RDV's analyses of an overview
// (or, for RDV, a whole state) — then the mode to open it in. The RDV card is offered to RDV and to the
// customers flagged for it (the server's view_safety_overview_full); whole states stay with RDV.
import React from 'react';
import rdvBall from '../../assets/rdv-logoBall.png';
import { MODES, isFull } from './modes';
import { sourceId } from './safetyOverviewApi';

export function RdvMark({ size = 18 }) {
  return <img src={rdvBall} alt="" className="so-rdv-mark" style={{ width: size, height: size }} />;
}

export default function StartScreen({ overviews, states, sourceKey, onSource, canFull, canAllRoads, lastMode, onChoose }) {
  const modes = MODES.filter((m) => canFull || !isFull(m.key));
  const hasData = Boolean(sourceKey);
  return (
    <div className="so-start">
      <div className="so-start-load">
        <label className="safety-filter" htmlFor="so-start-pick"><span>Data (RDV analyses)</span>
          <select id="so-start-pick" value={sourceKey || ''} onChange={(e) => onSource(e.target.value || null)}
            disabled={!overviews.length && !states.length}>
            {!overviews.length && !states.length && <option value="">Nothing to show yet</option>}
            {overviews.length > 0 && (
              <optgroup label="Overviews">
                {overviews.map((o) => <option key={o.id} value={sourceId('ov', o.id)}>{o.name} ({o.projects.length} project{o.projects.length === 1 ? '' : 's'})</option>)}
              </optgroup>
            )}
            {canAllRoads && states.length > 0 && (
              <optgroup label="Whole states (RDV)">
                {states.map((x) => <option key={x.id} value={sourceId('st', x.id)}>All collections in {x.label}</option>)}
              </optgroup>
            )}
          </select>
        </label>
        <p className="safety-muted so-start-hint">
          Choose the data, then how to look at it.{canFull ? ' Crash data, road features and the other data sets are in the RDV mode.' : ''}
        </p>
      </div>
      <div className="so-start-modes">
        {modes.map((m) => (
          <button key={m.key} type="button" disabled={!hasData}
            className={`so-mode-card ${m.rdv ? 'so-mode-rdv' : ''} ${lastMode === m.key ? 'so-mode-last' : ''}`}
            onClick={() => onChoose(m.key)} title={hasData ? `Open in ${m.label}` : 'Choose the data first'}>
            <span className="so-mode-icon">
              {m.rdv ? <RdvMark size={26} /> : <i className={`fa-solid ${m.icon}`} aria-hidden="true" />}
            </span>
            <span className="so-mode-name">{m.rdv ? <><b>RDV</b> · {m.label}</> : m.label}</span>
            <span className="so-mode-blurb">{m.blurb}</span>
            {lastMode === m.key && <span className="so-mode-tag so-mode-tag-last">last used</span>}
          </button>
        ))}
      </div>
    </div>
  );
}

/** The mode switch in the page header: every mode the user may open, the RDV one with its logo. */
export function ModeSwitch({ mode, canFull, onChange, onStart }) {
  const modes = MODES.filter((m) => canFull || !isFull(m.key));
  return (
    <div className="so-mode-switch" role="group" aria-label="Mode">
      <button type="button" className="so-mode-start" onClick={onStart} title="Back to the start screen">
        <i className="fa-solid fa-house" aria-hidden="true" />
      </button>
      {modes.map((m) => (
        <button key={m.key} type="button" aria-pressed={mode === m.key} onClick={() => onChange(m.key)} title={m.label}>
          {m.rdv ? <><RdvMark size={15} /> RDV</> : m.short}
        </button>
      ))}
    </div>
  );
}
